export default "__VITE_ASSET__DdAzePyO__"